import request from '../../utils/request'

const pre="/system/sysTenantPackage";

export const reqListSysTenantPackage = (data) => {
    return request({
        url: pre+'/page',
        method: 'POST',
        data: data
    })
}
export const reqListAllSysTenantPackage = (params) => {
    return request({
        url: pre+'/list',
        method: 'get',
        params
    })
}
export const reqInsertSysTenantPackage = (data) => {
    return request({
        url: pre+'/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateSysTenantPackage = (data) => {
    return request({
        url: pre+'/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteSysTenantPackage = (params) => {
    return request({
        url: pre+'/delete',
        method: 'get',
        params
    })
}
